export enum LoadingStrategy {
    SHARED="Shared",
    STAGED="Staged",
    STAGED_EVEN="Staged Even",
}